export default __webpack_public_path__ + "static/media/bg-interna01.a7b5ded9.jpg";